import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MarkantElementsModule } from '@markant/elements-angular';

@Component({
  standalone: true,
  selector: 'markant-platform-navigation-drawer-toggle',
  templateUrl: './drawer-toggle.component.html',
  styleUrls: ['./drawer-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MarkantElementsModule],
})
export class DrawerToggleComponent {
  @Input() icon = '';

  @Output() toggleDrawer = new EventEmitter<void>();
}
